import { createSlice } from '@reduxjs/toolkit';
import { IAgsExport } from 'Data/ViewModels/Ags';
import { IAgsExportState, InitAction, InitResolveAction, ReissueAction, ReissueResolveAction } from './types';

const initialState: IAgsExportState = {
  agsExportId: undefined,
  agsExport: undefined,
  pageHeader: {
    identifier: '',
    shortName: 'AGS Data',
    description: '',
    status: '',
    processing: false,
  },
  status: {
    ready: false,
    busy: false,
  },
};

const getIdentifier = (agsExport: IAgsExport) => {
  if (agsExport.WorkOrder) {
    return agsExport.WorkOrder.WorkOrderId;
  }
  if (agsExport.Project) {
    return agsExport.Project.Code;
  }
  return '';
};

const getDescription = (agsExport: IAgsExport) => {
  if (agsExport.WorkOrder) {
    return 'AGS Data for ' + agsExport.WorkOrder.WorkOrderId;
  }
  if (agsExport.Project && agsExport.StartDate && agsExport.EndDate) {
    return 'AGS Data for ' + agsExport.Project.Name + ' - ' + agsExport.StartDate + ' to ' + agsExport.EndDate;
  }
  return '';
};

const slice = createSlice({
  name: 'agsExport',
  initialState,
  reducers: {
    init(state, action: InitAction) {
      state.agsExportId = action.payload;
      state.status.ready = false;
    },
    initResolve(state, action: InitResolveAction) {
      state.agsExport = action.payload;
      state.status.ready = true;
      state.pageHeader.identifier = getIdentifier(action.payload);
      state.pageHeader.description = getDescription(action.payload);
    },
    initReject(state) {
      //maybe need to display an error ?
      state.agsExport = undefined;
      state.status.ready = true;
      state.pageHeader.identifier = '';
      state.pageHeader.description = '';
    },

    reissueExport(state, action: ReissueAction) {
      state.status.busy = true;
    },
    reissueExportResolve(state, action: ReissueResolveAction) {
      //Update state to include the newly created AGS revision
      if (state.agsExport?.Id === action.payload.AgsExportId) {
        state.agsExport.Revisions.push(action.payload);
      }
      state.status.busy = false;
    },
    reissueExportReject(state) {
      state.status.busy = false;
    },
  },
});

export const { actions, reducer } = slice;
export default slice.reducer;
